import {
	InputField,
	InputSelect,
	TableFilterWrapper,
} from '@welbe/web-design-system';
import { useContext } from 'react';
import { handleKeyPress } from 'utils/keyPressHandler';
import { HealthRiskAssessmentContext } from 'Views/HealthRiskAssessment/HealthRiskAssessment.context';
import { RiskLevelOptions } from '../../Population.constants';

type PopulationFiltersProps = {
	height: number;
	filters: { [key: string]: any };
	onSearch: () => void;
	onChangeFilters: (filter: { [key: string]: string | null }) => void;
};

export const PopulationFilters = ({
	height,
	filters,
	onSearch,
	onChangeFilters,
}: PopulationFiltersProps) => {
	const { assignedGroups, setSelectedGroup } = useContext(
		HealthRiskAssessmentContext,
	);

	const handleChangeGroup = (selectedOption: any) => {
		setSelectedGroup(selectedOption);
		onChangeFilters({
			hraGroupCompanyId: selectedOption.hraGroupCompanyId || '',
		});
	};

	return (
		<TableFilterWrapper height={height}>
			<InputSelect
				inputBackground="white"
				label="Grupo de riesgo"
				placeholder="Selecciona un grupo de riesgo"
				options={assignedGroups}
				showEmpty={false}
				value={assignedGroups?.find(
					(item: any) => item.hraGroupCompanyId === filters.hraGroupCompanyId,
				)}
				onChange={handleChangeGroup}
			/>
			<InputField
				background="white"
				label="Nombre del colaborador"
				placeholder="Buscar por nombre"
				onKeyPress={(e) => handleKeyPress(e, onSearch)}
				onChange={(value: any) => onChangeFilters({ name: value || '' })}
				value={filters.name}
			/>
			<InputSelect
				inputBackground="white"
				label="Nivel de riesgo"
				placeholder="Selecciona un nivel de riesgo"
				options={RiskLevelOptions}
				value={RiskLevelOptions.find(
					(item: any) => item.id === filters.riskLevel,
				)}
				onChange={(selectedOption: any) =>
					onChangeFilters({ riskLevel: selectedOption.id || '' })
				}
			/>
		</TableFilterWrapper>
	);
};
